export const generateUrl = calendarId => {
  return `https://calendar.google.com/calendar/embed?src=${encodeURI(
    calendarId,
  )}&amp;wkst=1&amp;bgcolor=%23ffffff&amp;ctz=America%2FRecife&amp;color=%23039BE5&amp;showTitle=1`;
};
